import Vue from 'vue'

//= lodash
import _ from 'lodash'
import VueLodash from 'vue-lodash'

import { en } from '@/assets/js/translations/permission-list/En'
import { kr } from '@/assets/js/translations/permission-list/Kr'
import { jp } from '@/assets/js/translations/permission-list/Jp'
import { zh } from '@/assets/js/translations/permission-list/Zh'

Vue.use(VueLodash, _)

export const translations = _.merge(en, kr, jp, zh)
